module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-legend"
  }, [_c('canvas', {
    ref: "legend",
    class: {
      active: _vm.highlighted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "handle",
    on: {
      "click": _vm.toggleHighlight
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5f99d06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map-legend.vue
// module id = 348
// module chunks = 1